
import React, { useState, useEffect } from 'react';
import { X, Gift, ArrowRight } from 'lucide-react';

const ExitIntent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [hasShown]);

  const handleGetScripts = () => {
    setIsVisible(false); // Close the popup first
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 300); // Small delay for smooth transition
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-[#0F1419]/90 backdrop-blur-md animate-in fade-in duration-300">
      <div className="bg-[#F4E4C1] max-w-2xl w-full rounded-[3rem] p-8 md:p-16 relative shadow-2xl border-4 border-[#FF6B35]">
        <button 
          onClick={() => setIsVisible(false)}
          className="absolute top-8 right-8 text-[#4E3629] hover:rotate-90 transition-transform"
        >
          <X className="w-8 h-8" />
        </button>

        <div className="text-center">
          <div className="w-20 h-20 bg-[#FF6B35] rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-xl shadow-orange-900/20">
            <Gift className="w-10 h-10 text-white" />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-black text-[#0F1419] uppercase italic tracking-tighter leading-none mb-6">
            Wait! Don't Leave <br /> Your Profit On The Table.
          </h2>
          
          <p className="text-xl font-bold text-[#4E3629] mb-10 leading-tight">
            Download my <span className="text-[#1A4D2E] underline">"7-Figure Follow-Up"</span> SMS Scripts. These are the exact messages closing 58% of our quotes. Free for a limited time.
          </p>

          <div className="space-y-4">
            <button 
              onClick={handleGetScripts}
              className="w-full bg-[#1A4D2E] hover:bg-[#FF6B35] text-white py-6 rounded-2xl text-2xl font-black transition-all shadow-xl uppercase flex items-center justify-center gap-4 group cursor-pointer"
            >
              GET THE SCRIPTS FREE <ArrowRight className="w-8 h-8 group-hover:translate-x-1 transition-transform" />
            </button>
            <button 
              onClick={() => setIsVisible(false)}
              className="text-xs font-black text-[#4E3629] uppercase tracking-widest opacity-50 hover:opacity-100 transition-opacity"
            >
              No thanks, I'm happy with my current closing rate.
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitIntent;
